export type SelectQueryBuilderOption = "disable-global-order"|"create-pojo";